import {BaseApi} from './BaseApi'
import {reportCatchError} from '../utils/errorReporter'

export interface OnboardApplicantResponse {
  success: boolean
  userId: string
}

/**
 * Candidate onboarding API (Platform Admin only).
 * Creates the candidate platform user (IOP-only — no Cognito) and sends the
 * IOP welcome email for an applicant that has no linked user yet.
 */
class CandidateOnboardingApiService extends BaseApi {
  private readonly basePath = '/candidate-onboarding'

  /**
   * One-time action: create the candidate login for an applicant and send the
   * welcome email. The backend rejects applicants that already have a user
   * or have no contact email.
   */
  async onboardApplicant(applicantId: string): Promise<OnboardApplicantResponse> {
    try {
      const response = await this.client.post<OnboardApplicantResponse>(
        `${this.basePath}/applicants/${applicantId}`,
      )
      return response.data
    } catch (error: unknown) {
      reportCatchError('Error onboarding candidate:', error)
      throw error
    }
  }
}

export const candidateOnboardingApi = new CandidateOnboardingApiService()
